module.exports = __webpack_public_path__ + "media/images/preview_asset_icon-8235cee871e451caa71315be40fcf131.svg";